import React, { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import "../../components/pdf/Fonts.js"
import styles from "../../components/pdf/Styles.js"

const MatingsRelationshipsPdf = ({
    matingsRelationships,
    femaleOwner,
    maleOwner,
    maleAnimal
}) => {
    return (
        <>
            <PDFViewer style={{ width: '99%', height: '100vh' }}>
                <Document>
                    <Page size='A4' orientation='landscape' style={styles.page} wrap>
                        <View style={styles.topColumn} fixed>
                            <View style={styles.headers_container}>
                                <Text style={styles.headers}>{'Εκτροφή κριού'}</Text>
                                <Text style={styles.headers}>{'Κωδικός κριού'}</Text>
                                <Text style={styles.headers}>{'Εκτροφή προβατίνας'}</Text>
                                <Text style={styles.headers}>{'Κωδικός προβατίνας'}</Text>
                                <Text style={styles.headers}>{'Δείκτης συγγένειας'}</Text>
                            </View>
                        </View>
                        <View style={styles.bottomColumns}>
                            {matingsRelationships.map((item, index) =>
                                <View key={index} style={styles.cells_container} wrap={false}>
                                    <Text style={styles.cell}>{maleOwner}</Text>
                                    <Text style={styles.cell}>{maleAnimal}</Text>
                                    <Text style={styles.cell}>{femaleOwner}</Text>
                                    <Text style={styles.cell}>{item?.registrationCode}</Text>
                                    <Text style={styles.cell}>{item?.relationship}</Text>
                                </View>
                            )}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(MatingsRelationshipsPdf);
